import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { creatorApi as n } from "@maat/api-main";
//#region src/creator/useCreatorTimeseriesQuery.ts
var r = (r) => t({
	queryKey: e.timeseries(r),
	queryFn: () => n.timeseries(r)
});
//#endregion
export { r as useCreatorTimeseriesQuery };
